<template>
  <v-app class="app-shell">
    <v-app-bar
      :class="['top-bar', { 'top-bar--hero': isHomeRoute }]"
      :elevation="isHomeRoute ? 0 : 1"
      :absolute="isHomeRoute"
    >
      <component
        :is="isHomeRoute ? 'span' : 'router-link'"
        v-bind="isHomeRoute ? {} : { to: '/' }"
        :class="[
          'brand-link',
          {
            'brand-link--hero': isHomeRoute,
            'brand-link--static': isHomeRoute,
          },
        ]"
        @click="isHomeRoute ? null : handleLogoClick()"
      >
        <img
          v-if="$config.companyLogo"
          :src="$config.companyLogo"
          alt="Company Logo"
          class="logo"
        />
      </component>
      <v-spacer></v-spacer>
      <v-btn
        v-if="$config.companyInfo.phone && !isHomeRoute"
        class="social-icon-btn"
        icon
        :href="phoneHref"
        title="Call us"
        aria-label="Call us"
      >
        <v-icon>mdi-phone</v-icon>
      </v-btn>
      <v-btn
        v-if="$config.companySocialMedia.facebook"
        class="social-icon-btn"
        icon
        :href="$config.companySocialMedia.facebook"
        target="_blank"
        title="Facebook"
      >
        <v-icon>mdi-facebook</v-icon>
      </v-btn>
      <v-btn
        v-if="$config.companySocialMedia.instagram"
        class="social-icon-btn"
        icon
        :href="$config.companySocialMedia.instagram"
        target="_blank"
        title="Instagram"
      >
        <v-icon>mdi-instagram</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>
    <v-footer
      :class="['site-footer', { 'site-footer--hero': isHomeRoute }]"
      :elevation="isHomeRoute ? 0 : 2"
    >
      <v-container class="py-1 py-md-2">
        <v-row align="center" class="footer-row">
          <v-col cols="12" md="8" class="text-center text-md-left">
            <div class="footer-brand">
              {{ $config.companyInfo.name }}
              <span class="footer-copyright">©</span>
            </div>
            <div class="footer-microcopy">
              Established 2011 • Licensed and insured
            </div>
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="text-center text-md-right footer-social"
          >
            <v-btn
              v-if="$config.companyInfo.phone"
              class="social-icon-btn"
              icon
              size="small"
              variant="text"
              :href="phoneHref"
              title="Call us"
              aria-label="Call us"
            >
              <v-icon>mdi-phone</v-icon>
            </v-btn>
            <v-btn
              v-if="$config.companySocialMedia.facebook"
              class="social-icon-btn"
              icon
              size="small"
              variant="text"
              :href="$config.companySocialMedia.facebook"
              target="_blank"
              title="Facebook"
            >
              <v-icon>mdi-facebook</v-icon>
            </v-btn>
            <v-btn
              v-if="$config.companySocialMedia.instagram"
              class="social-icon-btn"
              icon
              size="small"
              variant="text"
              :href="$config.companySocialMedia.instagram"
              target="_blank"
              title="Instagram"
            >
              <v-icon>mdi-instagram</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
  computed: {
    isHomeRoute() {
      return this.$route.name === "home";
    },
    phoneHref() {
      const digits = (this.$config.companyInfo.phone || "").replace(/\D/g, "");
      if (!digits) return "tel:";
      return digits.length === 10 ? `tel:+1${digits}` : `tel:${digits}`;
    },
  },
  methods: {
    handleLogoClick() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.logo {
  height: 52px;
  width: auto;
  display: block;
  margin-right: 12px;
  margin-left: 10px;
}

.app-shell {
  background: transparent;
}

.app-shell :deep(.v-main) {
  padding-bottom: 0 !important;
}

.top-bar {
  background: rgba(245, 241, 233, 0.92);
  backdrop-filter: blur(4px);
  border-bottom: 1px solid rgba(47, 77, 61, 0.12);
}

.top-bar--hero {
  z-index: 20;
  background: linear-gradient(
    180deg,
    rgba(8, 14, 11, 0.52) 0%,
    rgba(8, 14, 11, 0.24) 58%,
    rgba(8, 14, 11, 0) 100%
  );
  backdrop-filter: none;
  border-bottom: none;
}

.top-bar--hero :deep(.social-icon-btn .v-icon) {
  color: rgba(247, 238, 219, 0.96);
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

.top-bar--hero :deep(.social-icon-btn:hover) {
  background: rgba(250, 239, 214, 0.1);
}

.brand-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  border-radius: 10px;
  min-height: 46px;
  transition: background-color 0.2s ease, box-shadow 0.2s ease,
    transform 0.16s ease;
}

.brand-link--static {
  cursor: default;
  pointer-events: none;
}

.brand-link--hero .logo {
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.3));
}

.top-bar--hero .brand-link:hover {
  background: transparent;
  box-shadow: none;
}

.brand-link:hover {
  background: rgba(47, 77, 61, 0.08);
  box-shadow: inset 0 0 0 1px rgba(47, 77, 61, 0.18);
}

.brand-link:active {
  transform: translateY(1px);
}

.brand-link:focus-visible {
  outline: none;
  background: rgba(47, 77, 61, 0.1);
  box-shadow: inset 0 0 0 1px rgba(47, 77, 61, 0.2),
    0 0 0 2px rgba(183, 130, 70, 0.35);
}

.desktop-nav {
  align-items: center;
  margin-left: 10px;
}

.nav-link {
  min-height: 34px;
  border-radius: 0;
  padding: 0 4px;
  margin-left: 4px;
  color: #21382b;
  font-weight: 500;
  letter-spacing: 0.06em;
  font-size: 0.95rem;
  text-transform: uppercase;
  position: relative;
  opacity: 0.8;
  transition: opacity 0.2s ease, color 0.2s ease;
}

.nav-link::after {
  content: "";
  position: absolute;
  left: 6px;
  right: 6px;
  bottom: 4px;
  height: 2px;
  border-radius: 999px;
  background: #b78246;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.2s ease;
}

.desktop-nav :deep(.v-btn:hover) {
  background: transparent;
  opacity: 1;
  color: #16231b;
}

.desktop-nav :deep(.v-btn--active) {
  background: transparent;
  color: #16231b;
  opacity: 1;
}

.desktop-nav :deep(.v-btn--active)::after {
  transform: scaleX(1);
}

.site-footer {
  border-top: 1px solid rgba(47, 77, 61, 0.12);
  background: rgba(245, 241, 233, 0.92);
  backdrop-filter: blur(4px);
  color: #21382b;
}

.site-footer--hero {
  border-top: none;
  background: linear-gradient(
    0deg,
    rgba(8, 14, 11, 0.74) 0%,
    rgba(8, 14, 11, 0.46) 58%,
    rgba(8, 14, 11, 0) 100%
  );
  backdrop-filter: none;
  color: rgba(250, 242, 226, 0.98);
}

.footer-row {
  min-height: 58px;
}

.footer-brand {
  font-size: 1.22rem;
  font-family: "Cormorant Garamond", Georgia, "Times New Roman", serif;
  line-height: 1;
}

.footer-copyright {
  font-size: 0.52em;
  margin-left: 2px;
  vertical-align: super;
  line-height: 1;
}

.footer-microcopy {
  margin-top: 1px;
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(33, 56, 43, 0.72);
}

.site-footer--hero .footer-microcopy {
  color: rgba(250, 242, 226, 0.86);
}

.footer-social {
  white-space: nowrap;
}

.site-footer .social-icon-btn {
  color: var(--sal-forest-700) !important;
  width: 28px;
  height: 28px;
  min-width: 28px;
}

.site-footer .social-icon-btn:hover {
  color: var(--sal-forest-900) !important;
}

.site-footer--hero .social-icon-btn {
  color: rgba(250, 242, 226, 0.98) !important;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.52));
}

.site-footer--hero .social-icon-btn:hover {
  color: rgba(250, 242, 226, 0.98) !important;
  background: rgba(250, 239, 214, 0.16);
}

.social-icon-btn {
  color: var(--sal-forest-700) !important;
}

.social-icon-btn:hover {
  color: var(--sal-forest-900) !important;
}

@media (max-width: 768px) {
  .top-bar :deep(.v-toolbar__content) {
    padding-left: 8px;
    padding-right: 8px;
  }

  .site-footer :deep(.v-container) {
    padding-left: 16px;
    padding-right: 16px;
  }
}

@media (max-width: 600px) {
  .top-bar :deep(.v-toolbar__content) {
    padding-left: 4px;
    padding-right: 6px;
  }

  .logo {
    height: 46px;
    margin-left: 2px;
    margin-right: 8px;
  }

  .social-icon-btn {
    margin-left: 2px;
  }

  .footer-brand {
    font-size: 1.12rem;
  }

  .footer-row {
    min-height: 52px;
  }
}
</style>
